export const book = Object.freeze({
  default: "/",
  login: "/login",
  users: "/users",
  user: "/users/:id",
  transactions: "/transactions",
  products: "/products",
  cart: "/cart",
  requests: "/requests",
  myRequests: "/my-requests",
  admin: "/adminlog",
  error404: "/404",
});
